module.exports = __webpack_public_path__ + "static/media/money-bot.8f0b21d7.png";